import m from 'mithril'
import {
    Board,
} from '@base/app/models'
import {
    Dialog,
} from '@base/app/components'

import EditComponent from '../edit'
import PhotoComponent from '../photo'

// 常數定義
const CONSTANTS = {
    SQUARE_UNIT: 900,
    AREA_THRESHOLD_LOW: 210600,
    AREA_THRESHOLD_HIGH: 270000,
}

/**
 * 桌面版資料列元件
 */
export default class DesktopTableRow {
    view(vnode) {
        const { data, index, money, area, showPriceInfo, cities, types, methods, onUpdate } = vnode.attrs

        return m(`.col-12.px-0`, {
            style: {
                paddingBottom: data.is_later ? "1px" : ""
            }
        },
            m(".row.py-1.font-weight-bold.d-flex.align-items-center.m-0", {
                style: {
                    background: (index % 2 === 0) ? "#E8E8E8" : "#F4F4F4",
                    color: "#707070",
                    fontSize: "0.9rem",
                    borderStyle: "solid",
                    borderWidth: data.is_later ? "1px" : "0px",
                    borderColor: data.is_later ? "#B80D0D" : "",
                },
            }, [
                // 序號
                m(".col.px-0.text-center", {
                    style: {
                        maxWidth: "2%",
                        color: data.is_later ? "#B80D0D" : ""
                    },
                }, index + 1),

                // 地區
                m(".col.px-0.text-center", data.city),

                // 地址
                m(".col.px-0.text-center", {
                    style: { minWidth: "15%" },
                }, `${data.address}${(!data.subtitle) ? "" : `(${data.subtitle})`}`),

                // Google Maps 連結
                m(".col.px-0.d-flex.justify-content-center.align-items-center.text-center",
                    m("img.img-fluid", {
                        src: `${window.BASE_URL}/img/google.png`,
                        style: { maxHeight: "40px", maxWidth: "40px" },
                        onclick: (e) => {
                            e.preventDefault()
                            const url = data.type === "地址"
                                ? `https://www.google.com/maps/search/${data.city}${data.address}`
                                : `https://www.google.com/maps/search/${data.city}${data.address.replace('與', ' ')}`
                            window.open(url)
                        }
                    })
                ),

                // 照片 1
                m(".col.px-0.d-flex.justify-content-center.align-items-center.text-center",
                    this.renderPhotoIcon(data.photo)
                ),

                // 照片 2
                m(".col.px-0.d-flex.justify-content-center.align-items-center.text-center",
                    this.renderPhotoIcon(data.phototwo)
                ),

                // 廠商
                m(".col.px-0.text-center", {
                    style: {
                        color: (data.company === "優是") ? "#7C7AE8" : "",
                        fontSize: "1rem"
                    }
                }, data.company),

                // 鷹架
                m(".col.px-0.text-center",
                    data.is_eagle ? m("span", { style: { color: "#337C03", fontSize: "1.5rem" } }, "V") : ""
                ),

                // 尺寸
                m(".col.px-0.text-center", `${data.height} * ${data.width}`),

                // 裁數
                m(".col.px-0.text-center", { style: { minWidth: "10%" } }, [
                    m("span", { style: { fontSize: "1rem" } }, `${Math.ceil(area / CONSTANTS.SQUARE_UNIT)} 才`),
                    m("span.pl-1", {
                        style: {
                            color: (area > CONSTANTS.AREA_THRESHOLD_HIGH) ? "#337C03" : "#B4BBB1",
                            fontSize: "1rem",
                        }
                    }, (area > CONSTANTS.AREA_THRESHOLD_HIGH) ? "(足)" : "(不足)"),
                    (area >= CONSTANTS.AREA_THRESHOLD_LOW && area < CONSTANTS.AREA_THRESHOLD_HIGH) ?
                        m("span.badge.badge-danger.px-2.d-block", { style: { backgroundColor: "#E98873" } }, "以300才計算") : ""
                ]),

                // 吊車
                m(".col.px-0.text-center",
                    data.is_car ? m("span", { style: { color: "#337C03", fontSize: "1.5rem" } }, "V") : ""
                ),

                // 方式
                m(".col.px-0.text-center", data.method),

                // 租金
                m(".col.px-0.text-center", data.rent),

                // 窗口
                m(".col.px-0.text-center", { style: { minWidth: "6%" } },
                    m("p", { style: { wordWrap: "pre-wrap" } }, data.contact)
                ),

                // 電話
                m(".col.px-0.text-center", { style: { minWidth: "6%" } }, data.phone),

                // 備註
                m(".col.px-0.text-center", data.memo),

                // 價格
                showPriceInfo ? m(".col.px-0.text-center", m("span", `$ ${money}`)) : "",

                // 操作按鈕
                m(".col.px-0.text-center", { style: { minWidth: "10%" } },
                    this.renderActionButtons(vnode)
                ),
            ])
        )
    }

    renderPhotoIcon(photo) {
        if (!photo) return ""

        return m("img.img-fluid", {
            src: `${window.BASE_URL}/img/jpg.png`,
            style: { maxHeight: "60px", maxWidth: "40px" },
            onclick: (e) => {
                e.preventDefault()
                Dialog.show(PhotoComponent, {
                    attrs: { photo, type: "photo" },
                    didHide: () => {}
                })
            }
        })
    }

    renderActionButtons(vnode) {
        const { data, cities, types, methods, onUpdate } = vnode.attrs

        return [
            // 編輯按鈕
            m("button.btn.btn-primary.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0.px-2", {
                style: {
                    background: "#316A38",
                    color: "#FFF",
                    width: "50px"
                },
                onclick: (e) => {
                    e.preventDefault()
                    Dialog.show(EditComponent, {
                        attrs: {
                            model: new Board(data),
                            cities,
                            types,
                            methods
                        },
                        didHide: (returnValue) => {
                            if (returnValue) onUpdate()
                        }
                    })
                }
            }, m("span", "編輯")),

            // 正/延 按鈕
            m("button.btn.btn-danger.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0.px-2", {
                style: {
                    background: (!data.is_later) ? "#C7D9A4" : "#E6AAAA",
                    color: "#FFF"
                },
                onclick: (e) => {
                    e.preventDefault()
                    Board.changeStatus(data.id).then(() => {
                        data.is_later = !data.is_later
                    })
                }
            }, (!data.is_later) ? m("span", "正") : m("span", "延")),

            // 刪除按鈕
            m("button.btn.btn-danger.btn-sm.mx-0.mx-md-1.my-1.my-md-0[type='button'].border-0", {
                style: {
                    background: "#E6AAAA",
                    color: "#FFF"
                },
                onclick: (e) => {
                    e.preventDefault()
                    swal({
                        title: "是否確認刪除",
                        text: "刪除後將無法復原，請確認是否要刪除此筆資料!",
                        icon: "warning",
                        dangerMode: true,
                        buttons: ["取消", "確認"]
                    }).then((willDelete) => {
                        if (willDelete) {
                            Board.delete(data.id).then(() => {
                                swal("您的資料已成功刪除", {
                                    icon: "success",
                                    buttons: { cancel: false, confirm: "確認" },
                                }).then(() => onUpdate())
                            })
                        }
                    })
                }
            }, m("i.fa.fa-trash"))
        ]
    }
}
